import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SlideViewerFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-copyright',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './copyright.component.html',
    styleUrls: ['./copyright.component.scss'],
    standalone: false
})
export class CopyrightComponent {
  /**
   * Constructor
   *
   * @param slideViewerFacade
   */
  public constructor(public slideViewerFacade: SlideViewerFacade) {
  }
}
